// @flow
import * as React from "react";
import { Col } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { Controller } from "react-hook-form";

export const InputFormat = ({
  control,
  name,
  label,
  type,
  errors,
  required,
}) => {
  return (
    <Form.Group className="mb-3 w-75" >
      <Form.Label className="fw-bold pb-1">
        {label}
        {required && <span className="mx-1 text-danger">*</span>}
      </Form.Label>
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <Form.Control
            type={type}
            {...field}
            as={type === "textarea" ? "textarea" : undefined}
            rows={name === "Address" ? 3.8 : undefined}
          />
        )}
      />
      {errors && <div className="text-danger">{errors[name]?.message}</div>}
    </Form.Group>
  );
};
